// =========================================================
// Vojjin REGEX TEST Utilities
// =========================================================
import {registerGlobal} from "./core.js";

class Test {

    static #pregCheck(string, pattern) {
        if (Utils.isEmpty(string)) return false;
        return pattern.test(string);
    }

    /**
     * Validates a provided URL against a regex pattern.
     *
     * This function checks if the given URL matches a specific pattern for a valid
     * web address. The pattern ensures the URL can optionally start with "http://" or
     * "https://", followed by a domain name, a valid top-level domain, and optional
     * path segments.
     *
     * @param {string} url - The URL string to be validated.
     * @returns {boolean} Returns true if the URL matches the pattern; otherwise, false.
     */
    static url = (url) => {
        return this.#pregCheck(url, /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/);
    }

    /**
     * Validates an email address string against a standard email format.
     *
     * The function uses a regular expression to check if the provided email string
     * follows a standard email structure, which includes:
     * - A local part (before the @ symbol)
     * - An @ symbol separating the local part and the domain
     * - A valid domain structure (containing at least one dot)
     *
     * @param {string} email - The email address to be validated.
     * @returns {boolean} Returns true if the email matches the standard format, otherwise false.
     */
    static email = (email) => {
        return this.#pregCheck(email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    }

    /**
     * Validates a login string against a predefined pattern.
     *
     * The validation ensures the following:
     * - The login string must be between 3 and 16 characters in length.
     * - The login string can only contain alphanumeric characters, underscores (_), dashes (-), or spaces.
     *
     * @param {string} login - The login string to validate.
     * @returns {boolean} Returns `true` if the login string matches the pattern, otherwise `false`.
     */
    static login = (login) => {
        return this.#pregCheck(login, /^[a-zA-Z0-9_\- ]{3,16}$/);
    }

    /**
     * Validates and processes the provided player ID.
     *
     * This function checks if the given player ID matches a specific format
     * using a regular expression. The format allows alphanumeric characters,
     * underscores, hyphens, and spaces, with a maximum length of 8 characters.
     *
     * @param {string} player_id - The player ID to be validated.
     * @returns {boolean} Returns `true` if the player ID passes the validation check; otherwise, returns `false`.
     */
    static player_id = (player_id) => {
        return this.#pregCheck(player_id, /^[a-zA-Z0-9_\- ]{1,8}$/);
    }

    /**
     * Validates a coupon code against a predefined pattern.
     *
     * @param {string} coupon - The coupon code to be validated.
     * @returns {boolean} True if the coupon is valid based on the specified pattern, false otherwise.
     */
    static coupon = (coupon) => {
        return this.#pregCheck(coupon, /^[a-zA-Z0-9\_\-\!\.]{1,50}$/);
    }
}

registerGlobal("Test", Test);

